import Vue from "vue";
import * as utils from "@/utils/ganttUnit.js";
import CONSTNAME from "@/ConstName.js";
const mutation = {
  // 主题色
  set_theme(state, color) {
    if (state.theme != color) {
      state.theme = color;
    }
  },
  // 甘特图组件总宽
  setGanttWidth(state, newWidth) {
    if (typeof newWidth == "number") {
      state.ganttWidth = newWidth;
    }
  },
  // 甘特图组件总高
  setGanttHeight(state, newHeight) {
    if (typeof newHeight == "number") {
      state.ganttHeight = newHeight;
    }
  },
  // 时间轴单元格尺寸
  setCellWidth(state, newWidth = 80) {
    if (typeof newWidth == "number") {
      state.cellWidth = newWidth;
    }
  },
  setCellScale(state, newScale = 1) {
    if (typeof newScale == "number") {
      state.cellScale = newScale;
    }
  },
  setCellUnitType(state, newType = "day") {
    state.cellUnitType = newType;
  },
  // 横道
  setTasksArr(state, { arr, ganttType }) {
    if (arr instanceof Array) {
      state[ganttType + "_tasksArr"] = arr;
    }
  },
  // 点击任务块选中当前行背景
  setSelectTaskIndex(state, num = -1) {
    state.selectTaskIndex = num;
  },
  // 设置 是否显示统计区
  set_summaryShow(state, status = true) {
    if (state.summaryShow != status) {
      state.summaryShow = status;
    }
  },
  /* 设置时间轴起止 */
  set_cellStartAndEnd(state, newViewSchem = {}) {
    state.viewSchem.start = newViewSchem.start;
    state.viewSchem.end = newViewSchem.end;
  },
  // 设置左侧wbs视口宽度是否支持调整标记【auto(自动计算:多选50+树宽300+第一列宽·最大值400), config(配置优先), ignore(忽略)】
  setInitTableWidthFlag(state, flag = "auto") {
    if (typeof flag == "string") {
      state.initTableWidthFlag = flag;
    }
  },
  setInitTableWidth(state, num) {
    if (typeof num == "number" && num >= 0) {
      state.initTableWidth = num;
    }
  },
  // 设置显示模式left | both | right
  changeShowMode(state, type) {
    state.showMode = type;
  },
  // 设置树宽
  set_treeWidth(state, width = 100) {
    state.treeWidth = width;
  },
  // WBS头配置项
  set_wbsHeaderArr(state, arr) {
    state.wbsHeaderArr = arr;
  },
  // WBS行数据
  setwbsRowArr(state, arr) {
    if (arr instanceof Array) {
      const ganttType = arr[0] ? arr[0].ganttType : CONSTNAME.PLANS;
      state[ganttType + "_wbsRowArr"] = arr;

    }
  },
  // 初始化控件uuid
  setUuid(state, id = "default") {
    state.uuid = id;
  },
  // 控件初始化·数据加载态
  set_dataLoadingStatus(state, status = false) {
    state.dataLoadingStatus = status;
  },
  // 是否有更多加载内容
  set_hasNext(state, status = false) {
    if(state[CONSTNAME.PLANS + "_hasNext"] != status){
      state[CONSTNAME.PLANS + "_hasNext"] = status;
    }
  },
  // 是否保持原位
  set_stayInPlace(state, status = false) {
    if(state.stayInPlace != status){
      state.stayInPlace = status;
    }
  },
  // 全部刷新·初始化
  initGantt(state, res) {
    window.common_gantt_initStamp = Date.now();
    const _self = this;
    /* 重置: 通用 */
    state.stayInPlace = res.stayInPlace;
    //  时间轴·单行行高重置
    state.timesLineHeight = res.viewSchem.timesLineHeight >= 25 ? res.viewSchem.timesLineHeight : 25;
    // 横道区·单元行高重置
    state.cellHeight = res.viewSchem.cellRowHeight >= 30 ? res.viewSchem.cellRowHeight : 50;
    // 时间轴重置
    state.cellScale = res.viewSchem.cellScale || 1;
    // 横道选中重置
    state.selectTaskIndex = -1;
    // 虚线重置
    state.dashHeight = 0;
    state.dashDeg = 0;
    state.moveLinkFlag = false;
    // 权限
    state.accessLevel = res.accessLevel || 1;
    // 整体配置项
    state.viewSchem = Object.assign({}, state.viewSchem, res.viewSchem);
    
    _self.commit("setCellUnitType", state.viewSchem.cellUnitType);
    // 多语言字段
    _self.commit("set_lang", res.langMap);
    // WBS表头 => wbs内容宽
    state.wbsHeaderArr = res.columns;
    // 打印状态
    _self.commit("set_printStatus", false);
    // 显示模式重置
    if (res.viewSchem.showMode) {
      state.showMode = res.viewSchem.showMode || "both";
    }

    /* 重置: 回顶 */
    if (!res.stayInPlace) {
      // 树宽重置
      state.treeWidth = res.viewSchem.treeWidth || 300;
      // 左侧表格窗口宽度重置
      _self.commit("setInitTableWidthFlag", res.viewSchem.initTableWidthFlag); // 设置后重新计算到树位置
      state.initTableWidth = res.viewSchem.initTableWidth || 200;
      // 虚拟列表、 选中项
      state[CONSTNAME.PLANS + "_noUpdatePosition"] = false;
      state[CONSTNAME.PLANS + "_selectedArr"] = [];
      state[CONSTNAME.TODOS + "_noUpdatePosition"] = false;
      state[CONSTNAME.TODOS + "_selectedArr"] = [];
      
    }

    /* 主数据源·计划 */
    const _plans = res[CONSTNAME.PLANS];
    _self.commit("setwbsRowArr", _plans.dataList); // WBS行 => wbs视口宽
    state[CONSTNAME.PLANS + "_emptyTasksArr"] = _plans.emptyBarsList || []; // 空横道集合
    state[CONSTNAME.PLANS + "_tasksArr"] = _plans.taskDataList; // 横道集合
    // state[CONSTNAME.PLANS + "_tasksArr"] = _plans.taskDataList.filter((t, i, arr) => arr.findIndex(item => item.taskId === t.taskId) === i); // 横道集合
    state[CONSTNAME.PLANS + "_yLines"] = _plans.yLines;
    state[CONSTNAME.PLANS + "_map"] = _plans.dataListMap;
    state[CONSTNAME.PLANS + "_highlightType"] = "default"; // 高亮
    state[CONSTNAME.PLANS + "_dashedBar"] = { // 虚横道
      "show": false,
      "css": {
        "left": "0px",
        "top": "0px",
        "width": "0px",
        "height": "0px",
        "border-color": "red",
      },
    };
    state[CONSTNAME.PLANS + "_hasNext"] = _plans.hasNext || false; // 更多内容
    // console.log(state[CONSTNAME.PLANS + "_tasksArr"],"00000000000000000000000000000000000000");
    // 待排数据
    const _todoShow = res.viewSchem.todoShow;
    state.todoShow = _todoShow; // 是否显示待排区
    if (_todoShow) {
      const _todos = res[CONSTNAME.TODOS];
      state[CONSTNAME.TODOS + "_wbsRowArr"] = _todos.dataList;
      state[CONSTNAME.TODOS + "_emptyTasksArr"] = _todos.emptyBarsList || []; // 空横道集合·暂未启用
      state[CONSTNAME.TODOS + "_tasksArr"] = _todos.taskDataList;
      state[CONSTNAME.TODOS + "_yLines"] = _todos.yLines;
      state[CONSTNAME.TODOS + "_map"] = _todos.dataListMap;
      state[CONSTNAME.TODOS + "_highlightType"] = "default";
      state[CONSTNAME.TODOS + "_dashedBar"] = {
        "show": false,
        "css": {
          "left": "0px",
          "top": "0px",
          "width": "0px",
          "height": "0px",
          "border-color": "red",
        },
      };
      state[CONSTNAME.TODOS + "_rowsNum"] = _todos.showRows || 4;
      state[CONSTNAME.TODOS + "_hasNext"] = _todos.hasNext || false;
    }

    // 统计区
    const _summaryShow = res.viewSchem.summaryShow;
    state.summaryShow = _summaryShow; // 是否显示统计区
    if (_summaryShow) {
      const _summary = res[CONSTNAME.SUMMARY];
      state[CONSTNAME.SUMMARY + "_rowsNum"] = _summary.showRows || 3;
      state[CONSTNAME.SUMMARY + "_header"] = _summary.header || [];
      state[CONSTNAME.SUMMARY + "_body"] = _summary.body || {
        data: [],
        rate: [],
      };
    }

    state.dataLoadingStatus = false;
  },
  // 加载分批内容
  loadContent(state, obj){
    const {
      dataList,
      taskDataList,
      dataListMap,
      emptyBarsList,
      hasNext,
    } = obj[CONSTNAME.PLANS];
    dataList.length > 0 && state[CONSTNAME.PLANS + "_wbsRowArr"].splice(state[CONSTNAME.PLANS + "_wbsRowArr"].length, 0, ...dataList);
    taskDataList.length > 0 && state[CONSTNAME.PLANS + "_tasksArr"].splice(state[CONSTNAME.PLANS + "_tasksArr"].length, 0, ...taskDataList);
    state[CONSTNAME.PLANS + "_map"] = dataListMap;
    emptyBarsList.length > 0 && state[CONSTNAME.PLANS + "_emptyTasksArr"].splice(state[CONSTNAME.PLANS + "_emptyTasksArr"].length, 0, ...emptyBarsList);
    state[CONSTNAME.PLANS + "_hasNext"] = hasNext;
    
    state.dataLoadingStatus = false;
  },
  /* 
    // 局部更新内容
    {
      methodName: "gtRefreshContent",
      success: true,
      message: "加载内容",
      data: {
        pageData: {
          dataList: [
            {
              start: 0,
              deleteLen: 0,
              items: ["待插入行"],
            }
          ],
          taskDataList: [], // 同 dataList
          emptyBarsList: [], // 同 dataList
          dataListMap: {},
          hasNext: false,
        },
        todo: {
          dataList: [], // 同 dataList
          taskDataList: [], // 同 dataList
          dataListMap: {},
          hasNext: false,
        }
      }
    }
  */
  updateContent(state, obj){
    const {
      dataList,
      taskDataList,
      dataListMap,
      emptyBarsList,
      hasNext,
    } = obj[CONSTNAME.PLANS];
    for (let row of dataList) {
      const {start, deleteLen, items} = row;
      let arg = [start, deleteLen];
      if(items && items.length > 0){ arg = [...arg, ...items]; }
      state[CONSTNAME.PLANS + "_wbsRowArr"].splice(...arg);
    }
    for (let task of taskDataList) {
      const {start, deleteLen, items} = task;
      let arg = [start, deleteLen];
      if(items && items.length > 0){ arg = [...arg, ...items]; }
      state[CONSTNAME.PLANS + "_tasksArr"].splice(...arg);
    }
    state[CONSTNAME.PLANS + "_map"] = dataListMap;
    for (let emptyTask of emptyBarsList) {
      const {start, deleteLen, items} = emptyTask;
      let arg = [start, deleteLen];
      if(items && items.length > 0){ arg = [...arg, ...items]; }
      state[CONSTNAME.PLANS + "_emptyTasksArr"].splice(...arg);
    }
    state[CONSTNAME.PLANS + "_hasNext"] = hasNext;
    
    if( state.todoShow ){
      const {
        dataList,
        taskDataList,
        dataListMap,
        hasNext,
      } = obj[CONSTNAME.TODOS];
      for (let row of dataList) {
        const {start, deleteLen, items} = row;
        let arg = [start, deleteLen];
        if(items && items.length > 0){ arg = [...arg, ...items]; }
        state[CONSTNAME.TODOS + "_wbsRowArr"].splice(...arg);
      }
      for (let task of taskDataList) {
        const {start, deleteLen, items} = task;
        let arg = [start, deleteLen];
        if(items && items.length > 0){ arg = [...arg, ...items]; }
        state[CONSTNAME.TODOS + "_tasksArr"].splice(...arg);
      }
      state[CONSTNAME.TODOS + "_map"] = dataListMap;
      state[CONSTNAME.TODOS + "_hasNext"] = hasNext;
    }

    if(
      obj.viewSchem &&
      typeof obj.viewSchem == 'object'
    ) {
      Vue.set(state, "viewSchem", obj.viewSchem);
      console.log("配置更新", obj.viewSchem);
    }
    state.dataLoadingStatus = false;
  },

  // 设置指示虚线起点位置
  set_dashLine_pos(state, { dashPosTop = 0, dashPosLeft = 0, ganttType = CONSTNAME.PLANS }) {
    state.dashPosTop = dashPosTop;
    state.dashPosLeft = dashPosLeft;
    state.ganttType = ganttType;
  },
  // 设置指示虚线样式
  set_dashLines_css(state, { dashHeight = 0, dashDeg = 0, moveLinkFlag = false }) {
    state.dashHeight = dashHeight;
    state.dashDeg = dashDeg;
    state.moveLinkFlag = moveLinkFlag;

  },
  // 设置打印状态·本地
  set_printStatus(state, status = false) {
    state.printStatus = status;
  },
  // 删除 *** 环境上暂未使用 ***
  deleteWBS(state, { index, item }) {
    const targetMap = state[item.ganttType + "_map"];
    const target = state[item.ganttType + "_wbsRowArr"];

    const _sourceRealRow = targetMap[item.id].realRow;
    const _sourceRowCount = targetMap[item.id].rowCount;
    // console.log("删除行", index, item, _sourceRealRow);
    if (
      index >= 0 &&
      index <= target.length - 1
    ) {
      target.splice(index, 1);
      // const _rowIndex = utils.fnGetIndex(item.id, state[ganttType + "_map"]);
      // console.log("删除行", _rowIndex, target, state[ganttType + "_map"], state[ganttType + "_map"][item.id]);
      delete state[item.ganttType + "_map"][item.id];
      for (const key in state[item.ganttType + "_map"]) {
        const pkItem = state[item.ganttType + "_map"][key];
        if (key == "totalRow") {
          state[item.ganttType + "_map"][key] -= _sourceRowCount;
          continue;
        }
        if (pkItem.realRow > _sourceRealRow) {
          // console.log(pkItem.ganttType, pkItem);
          pkItem.startRow -= _sourceRowCount;
          pkItem.realRow -= 1;
        }
      }
      // console.log(state[item.ganttType + "_map"], state[item.ganttType + "_map"][item.id]);

    }

  },
  // 新增空WBS任务行
  addEmptyWBS(state, { item, ganttType }) {
    const target = state[ganttType + "_tasksArr"];

    target.push(item);
  },
  // 修改已有WBS
  changeOldWBS(state, { item, index }) {
    const target = state[item.ganttType + "_wbsRowArr"];
    target.splice(index, 1, item);
  },
  // 修改已有任务
  changeOldTask(state, { item, index, mapKey }) {
    const target = state[item.ganttType + "_tasksArr"];
    target.splice(index, 1, item);

  },
  // 上移
  upWBS(state, { index, arr }) {
    utils.upGo(arr, index);
  },
  // 下移
  downWBS(state, { index, arr }) {
    utils.downGo(arr, index);
  },
  // 设置拖拽横道状态
  set_isDragging(state, Bool = false) {
    if (state.isDragging !== Bool) {
      state.isDragging = Bool;
    }
  },

  // 设置操作数据源类型
  set_ganttType(state, Str = CONSTNAME.PLANS) {
    if (Str != state.ganttType) {
      state.ganttType = Str;
    }
  },
  // 行·映射字典
  set_dataListMap(state, { dataListMap, ganttType }) {
    state[ganttType + "_map"] = dataListMap;
  },
  // 垂直线
  set_yLines(state, { yLines, ganttType }) {
    if (yLines instanceof Array && yLines.length > 0) {
      state[ganttType + "_yLines"] = yLines;
    }
  },
  // 更新分区主数据·【20240325后废弃被局部更新替代】
  updateMainData(state, data) {
    const _self = this;
    /* 重置: 通用 */
    // 打印状态
    _self.commit("set_printStatus", false);
    const { ganttType = CONSTNAME.PLANS } = data;
    if (data[ganttType]) {
      const { dataList, taskDataList, dataListMap, yLines, height, emptyBarsList, hasNext } = data[ganttType];
      // console.log("更新块数量: ", { dataList, taskDataList, dataListMap, yLines, height, emptyBarsList, hasNext });
      state[ganttType + "_noUpdatePosition"] = false;

      state[ganttType + "_wbsRowArr"] = dataList || [];
      state[ganttType + "_tasksArr"] = taskDataList || [];
      state[ganttType + "_map"] = dataListMap || null;

      if (yLines) { state[ganttType + "_yLines"] = yLines; }
      if (emptyBarsList) { state[ganttType + "_emptyTasksArr"] = emptyBarsList; }
      state[ganttType + "_dashedBar"] = {
        "show": false,
        "css": {
          "left": "0px",
          "top": "0px",
          "width": "0px",
          "height": "0px",
          "border-color": "red",
        },
      };
      state[ganttType + "_hasNext"] = hasNext || false;
    }
    // 统计区
    const _summaryShow = state.summaryShow;
    if (_summaryShow) {
      const _summary = data[CONSTNAME.SUMMARY];
      state[CONSTNAME.SUMMARY + "_header"] = _summary.header || [];
      state[CONSTNAME.SUMMARY + "_body"] = _summary.body || {
        data: [],
        rate: [],
      };
    }

  },
  // 交换分区主数据·计划区 待排区跨区拖拽·【20240325后废弃被局部更新替代】
  exchangeMainData(state, data) {
    const _self = this;
    /* 重置: 通用 */
    // 打印状态
    _self.commit("set_printStatus", false);
    const { ganttType, targetGanttType } = data;
    if (data[ganttType]) {
      const { dataList, taskDataList, dataListMap, yLines, emptyBarsList, hasNext } = data[ganttType];
      // console.log("更新块数量: ", { dataList, taskDataList, dataListMap, yLines, emptyBarsList, hasNext });
      state[ganttType + "_noUpdatePosition"] = false;

      state[ganttType + "_wbsRowArr"] = dataList || [];
      state[ganttType + "_tasksArr"] = taskDataList || [];
      state[ganttType + "_map"] = dataListMap || null;

      if (yLines) { state[ganttType + "_yLines"] = yLines; }
      if (emptyBarsList) { state[ganttType + "_emptyTasksArr"] = emptyBarsList; }
      state[ganttType + "_dashedBar"] = {
        "show": false,
        "css": {
          "left": "0px",
          "top": "0px",
          "width": "0px",
          "height": "0px",
          "border-color": "red",
        },
      };
      state[ganttType + "_hasNext"] = hasNext || false;
    }
    if (
      targetGanttType != ganttType &&
      data[targetGanttType]
    ) {
      const { dataList, taskDataList, dataListMap, yLines, emptyBarsList, hasNext } = data[targetGanttType];
      // console.log("更新块数量: ", { dataList, taskDataList, dataListMap, yLines, emptyBarsList, hasNext });
      state[targetGanttType + "_noUpdatePosition"] = false;

      state[targetGanttType + "_wbsRowArr"] = dataList || [];
      state[targetGanttType + "_tasksArr"] = taskDataList || [];
      state[targetGanttType + "_map"] = dataListMap || null;

      if (yLines) { state[targetGanttType + "_yLines"] = yLines; }
      if (emptyBarsList) { state[targetGanttType + "_emptyTasksArr"] = emptyBarsList; }
      state[targetGanttType + "_dashedBar"] = {
        "show": false,
        "css": {
          "left": "0px",
          "top": "0px",
          "width": "0px",
          "height": "0px",
          "border-color": "red",
        },
      };
      state[targetGanttType + "_hasNext"] = hasNext || false;
    }
    // 统计区
    const _summaryShow = state.summaryShow;
    if (_summaryShow) {
      const _summary = data[CONSTNAME.SUMMARY];
      state[CONSTNAME.SUMMARY + "_header"] = _summary.header || [];
      state[CONSTNAME.SUMMARY + "_body"] = _summary.body || {
        data: [],
        rate: [],
      };
    }

  },

  // 设置行位置信息重算开关
  set_noUpdatePosition(state, { status = false, ganttType = CONSTNAME.PLANS }) {
    if (state[ganttType + "_noUpdatePosition"] !== status) {
      state[ganttType + "_noUpdatePosition"] = status;
    }
  },
  // 切换选中项·单条
  set_selectStatus_item(state, { ganttType, id, status }) {
    const target = state[ganttType + "_selectedArr"];
    const index = target.indexOf(id);
    if (status === true && index == -1) {
      target.splice(target.length, 1, id);
      // console.log("新增");
    } else if (status === false && index !== -1) {
      target.splice(index, 1);
      // console.log("删除");
    }
  },
  // 设置选中项·单区域全集合
  set_selectStatus_area(state, { ganttType, selectedArr = [] }) {
    state[ganttType + "_selectedArr"] = [...selectedArr];
    // console.log("最新选中项集合: ", state[ganttType + "_selectedArr"]);
  },
  // 设置高亮横道类型·单条
  set_highlightType(state, { ganttType, type = "default" }) {
    const target = state[ganttType + "_highlightType"];
    if (target !== type) {
      state[ganttType + "_highlightType"] = type;
      // console.log("更新高亮");
    }
  },
  // 设置多语言集合
  set_lang(state, obj = {}) {
    state.langMap = obj;
  },


  // 设置连线显示开关
  set_isLineShow(state, status = false) {
    if (state.viewSchem.isLineShow != status) {
      state.viewSchem.isLineShow = status;
    }
  },
  // 设置时间轴内容显示几级
  set_timelineShowRows(state, num = 2) {
    if (
      typeof num == "number" &&
      state.viewSchem.timelineShowRows != num
    ) {
      state.viewSchem.timelineShowRows = num;
    }
  },
  // 设置时间轴·自增排序显示开关
  set_isRankMode(state, status = false) {
    if (state.viewSchem.isRankMode != status) {
      state.viewSchem.isRankMode = status;
    }
  },
  // 设置时间轴·周几首字母显示开关
  set_isWeekCodeMode(state, status = false) {
    if (state.viewSchem.isWeekCodeMode != status) {
      state.viewSchem.isWeekCodeMode = status;
    }
  },
  // 设置时间轴二级菜单是否竖直显示开关
  set_isVerticalMode(state, status = false) {
    if (state.viewSchem.isVerticalMode != status) {
      state.viewSchem.isVerticalMode = status;
    }
  },
  // 设置是否显示空白横道开关
  set_emptyBarsShow(state, status = false) {
    if (state.viewSchem.emptyBarsShow != status) {
      state.viewSchem.emptyBarsShow = status;
    }
  },
  // 设置是否显示正常横道开关
  set_normalBarsShow(state, status = true) {
    if (state.viewSchem.normalBarsShow != status) {
      state.viewSchem.normalBarsShow = status;
    }
  },
  // 设置 横道显示筛选·关键路径横道
  set_taskFilter3(state, status = false) {
    if (state.viewSchem.taskFilter3 != status) {
      state.viewSchem.taskFilter3 = status;
    }
  },
  // 设置 横道显示筛选·二级关键路径横道
  set_taskFilter6(state, status = false) {
    if (state.viewSchem.taskFilter6 != status) {
      state.viewSchem.taskFilter6 = status;
    }
  },
  // 设置 常规任务横道是否不显示圆角
  set_noTaskBorderRadiusShow(state, status = false) {
    if (state.viewSchem.noTaskBorderRadiusShow != status) {
      state.viewSchem.noTaskBorderRadiusShow = status;
    }
  },
  // 设置 常规任务横道是否显示黑色边框
  set_isTaskBorderShow(state, status = false) {
    if (state.viewSchem.isTaskBorderShow != status) {
      state.viewSchem.isTaskBorderShow = status;
    }
  },
  // 设置 表单行是否显示勾选框
  set_isRowCheckBoxShow(state, status = true) {
    if (state.viewSchem.isRowCheckBoxShow != status) {
      state.viewSchem.isRowCheckBoxShow = status;
    }
  },
  // 设置 表单行是否显示名称前置图标
  set_isRowIconShow(state, status = true) {
    if (state.viewSchem.isRowIconShow != status) {
      state.viewSchem.isRowIconShow = status;
    }
  },
  // 设置 拖拽目标类型
  set_dropTargetType(state, status = 1) {
    if (state.viewSchem.dropTargetType != status) {
      state.viewSchem.dropTargetType = status;
    }
  },
  // 设置 是否显示拖拽垂直标尺辅助线
  set_isDropYAxisShow(state, status = false) {
    if (state.viewSchem.isDropYAxisShow != status) {
      state.viewSchem.isDropYAxisShow = status;
    }
  },
  // 设置 时间轴补足填充模式
  set_timelineFillType(state, status = 1) {
    if (state.viewSchem.timelineFillType != status) {
      state.viewSchem.timelineFillType = status;
    }
  },
  // 设置 表格列是否支持调整
  set_tableLineAdjustable(state, status = true) {
    if (state.viewSchem.tableLineAdjustable != status) {
      state.viewSchem.tableLineAdjustable = status;
    }
  },
  // 设置 是否显示非工作日背景
  set_weekedBgShow(state, status = true) {
    if (state.viewSchem.weekedBgShow != status) {
      state.viewSchem.weekedBgShow = status;
    }
  },
  // 设置 树结构显示 字体大小
  set_treeFontSize(state, num = 12) {
    if (state.viewSchem.treeFontSize != num) {
      state.viewSchem.treeFontSize = num;
    }
  },
  // 设置 树结构显示·字体加粗
  set_treeFontWeight(state, str = "") {
    if (state.viewSchem.treeFontWeight != str) {
      state.viewSchem.treeFontWeight = str;
    }
  },
  // 设置 无甘特图外边框
  set_noGanttOutBoxBorder(state, status = false) {
    if (state.viewSchem.noGanttOutBoxBorder != status) {
      state.viewSchem.noGanttOutBoxBorder = status;
    }
  },
  // 设置 选择横道是否选中所属行
  set_isBarSelectRow(state, status = false) {
    if (state.viewSchem.isBarSelectRow != status) {
      state.viewSchem.isBarSelectRow = status;
    }
  },
  // 设置 是否打印显示模式(不限高·平铺计划区)
  set_isPrintModeShow(state, status = false) {
    if (state.viewSchem.isPrintModeShow != status) {
      state.viewSchem.isPrintModeShow = status;
    }
  },
  // 设置 打印质量最大缩放比例
  set_printMaxScale(state, oldScale = 2) {
    if (state.viewSchem.printMaxScale != oldScale) {
      state.viewSchem.printMaxScale = oldScale;
    }
  },
  // 设置 打印预览模式尺寸比·宽
  set_printModeWidth(state, num = 100) {
    if (
      state.viewSchem.printModeWidth != num &&
      typeof num == "number" &&
      num > 0
    ) {
      state.viewSchem.printModeWidth = num;
    }
  },
  // 设置 打印预览模式尺寸比·高
  set_printModeHeight(state, num = 100) {
    if (
      state.viewSchem.printModeHeight != num &&
      typeof num == "number" &&
      num > 0
    ) {
      state.viewSchem.printModeHeight = num;
    }
  },
  // 设置 同时修改打印预览模式尺寸比·宽+高
  set_printModeSize(state, { printModeWidth, printModeHeight }) {
    if (
      state.viewSchem.printModeWidth != printModeWidth &&
      typeof printModeWidth == "number" &&
      printModeWidth > 0
    ) {
      state.viewSchem.printModeWidth = printModeWidth;
    }
    if (
      state.viewSchem.printModeHeight != printModeHeight &&
      typeof printModeHeight == "number" &&
      printModeHeight > 0
    ) {
      state.viewSchem.printModeHeight = printModeHeight;
    }
  },
  // 设置 巴条标签文字大小
  set_barsFontSize(state, num = 12) {
    if (state.viewSchem.barsFontSize != num) {
      state.viewSchem.barsFontSize = num;
    }
  },
  // 设置 时间轴周字母显示数量
  set_timelineWeekCodeShowNums(state, num = 1) {
    if (state.viewSchem.timelineWeekCodeShowNums != num) {
      state.viewSchem.timelineWeekCodeShowNums = num;
    }
  },
  // 设置 时间轴字体大小正常显示(非加粗)
  set_timeLineFontNomal(state, status = false) {
    if (state.viewSchem.timeLineFontNomal != status) {
      state.viewSchem.timeLineFontNomal = status;
    }
  },
  // 设置 时间轴·单行行高
  set_timesLineHeight(state, height = 25) {
    if (state.timesLineHeight != height) {
      state.timesLineHeight = height;
      state.viewSchem.timesLineHeight = height;
    }
  },
  // 设置 横道区·单元行高
  set_cellHeight(state, height = 25) {
    if (state.cellHeight != height) {
      state.cellHeight = height;
      state.viewSchem.cellRowHeight = height;
    }
  },
  // 设置 时间轴·字体大小
  set_timelineFontSize(state, number = 12) {
    if (state.viewSchem.timelineFontSize !== number) {
      state.viewSchem.timelineFontSize = number;
    }
  },
  // 设置 连线关系·颜色
  set_linkLineColor(state, color = "#ec9f2c") {
    if (state.viewSchem.linkLineColor !== color) {
      state.viewSchem.linkLineColor = color;
    }
  },

  // 设置 展示背景色日期·集合
  set_timelineBgDates(state, arr = []) {
    Vue.set(state.viewSchem, "timelineBgDates", arr);
  },

  // 设置 展示背景色日期·背景颜色值
  set_timelineBgDatesColor(state, color = "rgba(0,0,0,0.3)") {
    if (state.viewSchem.timelineBgDatesColor !== color) {
      state.viewSchem.timelineBgDatesColor = color;
    }
  },

  /* 设置视图通用项内配置 */
  set_viewSchem(state, newViewSchem = {}) {
    if (newViewSchem != null && typeof newViewSchem === "object") {
      state.cellHeight = newViewSchem.cellRowHeight >= 30 ? newViewSchem.cellRowHeight : 50;// 设置行高
      state.viewSchem.isLineShow = newViewSchem.isLineShow;
      state.viewSchem.timelineShowRows = newViewSchem.timelineShowRows;
      state.viewSchem.isRankMode = newViewSchem.isRankMode;
      state.viewSchem.isWeekCodeMode = newViewSchem.isWeekCodeMode;
      // state.viewSchem.isVerticalMode = newViewSchem.isVerticalMode; // 垂直模式切换涉及数据重排·排除在外
      state.viewSchem.emptyBarsShow = newViewSchem.emptyBarsShow;
      state.viewSchem.normalBarsShow = newViewSchem.normalBarsShow;
      state.viewSchem.taskFilter3 = newViewSchem.taskFilter3;
      state.viewSchem.taskFilter6 = newViewSchem.taskFilter6;
      state.viewSchem.noTaskBorderRadiusShow = newViewSchem.noTaskBorderRadiusShow;
      state.viewSchem.isTaskBorderShow = newViewSchem.isTaskBorderShow;
      state.viewSchem.isRowCheckBoxShow = newViewSchem.isRowCheckBoxShow;
      state.viewSchem.isRowIconShow = newViewSchem.isRowIconShow;
      state.viewSchem.weekedBgShow = newViewSchem.weekedBgShow;
      state.viewSchem.isBarSelectRow = newViewSchem.isBarSelectRow;
      state.viewSchem.timelineWeekCodeShowNums = newViewSchem.timelineWeekCodeShowNums || 1;
      state.viewSchem.isDropYAxisShow = newViewSchem.isDropYAxisShow || false;
      state.viewSchem.timeLineFontNomal = newViewSchem.timeLineFontNomal || false;
      if (newViewSchem.timelineFontSize > 0) {
        state.viewSchem.timelineFontSize = newViewSchem.timelineFontSize;
      }

    }
  },
  /* 设置统计区显示数据及开关 */
  set_summary(state, data) {
    const _summaryShow = data.summaryShow;
    state.summaryShow = _summaryShow;
    state.viewSchem.summaryShow = _summaryShow; // 同步更新设置数据里的保持一致
    if (_summaryShow) {
      const _summary = data[CONSTNAME.SUMMARY];
      state[CONSTNAME.SUMMARY + "_rowsNum"] = _summary.showRows || 3;
      state[CONSTNAME.SUMMARY + "_header"] = _summary.header || [];
      state[CONSTNAME.SUMMARY + "_body"] = _summary.body || {
        data: [],
        rate: [],
      };
    }
  },
  /* 设置 搜索到的目标横道集合 */
  set_viewSchem_searchedList(state, newList = []) {
    if (newList != null && newList instanceof Array) {
      state.viewSchem.searchedList = newList;
    }
  },
  // 设置 虚拟阀值
  set_virtualStartNum(state, num = CONSTNAME.VIRTUAL_START_NUM) {
    if (num > 199) {
      state.viewSchem.virtualStartNum = num;
    }
  },
  // 设置 展示搜索到的目标横道的下标值
  set_searchedActNum(state, index = 0) {
    if (typeof index == "number") {
      state.searchedActNum = index;
    }
  },


  // 设置 虚线横道
  set_dashedBar(state, {
    ganttType = CONSTNAME.PLANS,
    dashedBar = {
      "show": false,
      "css": {
        "left": "0px",
        "top": "0px",
        "width": "0px",
        "height": "0px",
        "border-color": "red",
      },
    },
  }) {
    state[ganttType + "_dashedBar"] = dashedBar;
    // console.log("更新虚横道");
  },

  // 设置拖拽垂直指引线
  set_guideYAxis(state, info = null) {
    state.guideYAxis = info;
  },
  // 设置拖拽垂直指引线
  set_ganttName(state, ganttName) {
    state.viewSchem.ganttName = ganttName;
  },
};
export default mutation;
